import React from 'react'
import useSWR from 'swr';
import { useParams, useSearchParams } from 'react-router-dom';
import Pagination from 'components/Pagination';
import { ProductCard } from 'components/Cards';
import ProductSkeleton from './ProductSkeleton';
import EmptyList from './EmptyList';
import { useStores } from 'hooks/useStores';
import { PAGE_KEY, PER_PAGE } from '../const';

import style from '../styles/goods.module.scss';

const GoodList = () => {
  const { api } = useStores();
  const { slug, subgroupSlug } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const page = Number(searchParams.get(PAGE_KEY) ?? 1);

  const swrKey = {
    slug,
    page,
    _key: `ng-products-list-${slug}`,
  };

  if (subgroupSlug) {
    swrKey.subgroup = subgroupSlug;
  }

  const FILTER_PARAMS = ['price_min', 'price_max', 'in_stock', 'param'];
  FILTER_PARAMS.forEach((key) => {
    const val = searchParams.get(key);
    if (val !== null) {
      swrKey[key] = val;
    }
  });

  const { data, isLoading } = useSWR(
    swrKey,
    api.newCatalog.getNgProductsBySlug
  );

  const handelChangePage = (newPage) => {
    setSearchParams(searchParams => {
      searchParams.set(PAGE_KEY, newPage);
      return searchParams;
    });
  }

  if (isLoading) {
    return <ProductSkeleton />
  }

  if (!isLoading && data?.results?.length === 0) return <EmptyList />

  return (
    <div className={style.goods}>
      <div className={style.goods__list}>
        {
          data?.results?.map((product) => (
              <ProductCard key={product.id}  product={product} />
          ))
        }
      </div>
          <Pagination
          paginationProps={{
            onChange:handelChangePage,
            current:page,
            showLessItems: true,
            pageSize: data?.per_page ?? PER_PAGE,
            total:data?.count ?? 0
          }}
          />
    </div>
  )
}

export default GoodList
